
import { all } from "redux-saga/effects";
import { authWatchers } from "../modules/auth/sagas";
import { anagrafeWatchers } from "../modules/anagrafe/sagas";
import { profilazioneWatchers } from "../modules/profilazione/sagas";
import { screeningWatchers } from "../modules/screening/sagas";
import { resetWatchers } from "../modules/reset/sagas";
import { screeningColonRettoWatchers } from "../modules/screeningColonRetto/sagas";
import { screeningMammograficoWatchers } from "../modules/screeningMammografico/sagas";
import { postloginWatchers } from "../modules/postLogin/sagas";
import { persistentStoreWatchers } from "../modules/persistentStore/sagas";

const allSagas = [
  authWatchers(),
  anagrafeWatchers(),
  persistentStoreWatchers(),
  profilazioneWatchers(),
  screeningWatchers(),
  screeningColonRettoWatchers(),
  screeningMammograficoWatchers(),
  resetWatchers(),
  postloginWatchers(),
];

export const createSagas = () =>
  function* combineSagas() {
    yield all(allSagas);
  };
